import { createFilterOptions } from '@mui/material'
import { Filter } from 'components/core/search-filter/filter'
import { GetDepartmentSearchTermsRequest } from 'pbts/c1/api/user/v1/user'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { getDepartmentSearchTermsApi } from 'redux_toolkit/users'

const UserDepartmentFilterOptions = createFilterOptions<string>({})

type UserDepartmentFilterProps = {
    value?: Array<string>
    onChange: (updated: { departments: Array<string> }, shouldPropagate?: boolean) => void
}

export const UserDepartmentFilter = ({ value, onChange: _onChange }: UserDepartmentFilterProps): React.ReactElement => {
    const intl = useIntl()
    const { data: departmentResponse } = getDepartmentSearchTermsApi.useGetDepartmentSearchTerms(
        GetDepartmentSearchTermsRequest.create({}),
    )

    const departmentOptions = departmentResponse?.terms || []

    const renderLabel = useCallback(
        (department: string): string => department,
        [],
    )

    const onChange = useCallback((departments: Array<string>) => _onChange({ departments }, true), [_onChange])

    return (
        <Filter
            label={intl.formatMessage({
                id: 'user_filter_department_type',
                defaultMessage: 'Department',
            })}
            options={departmentOptions}
            selected={value}
            onChange={onChange}
            filterOptions={UserDepartmentFilterOptions}
            renderLabel={renderLabel}
        />
    )
}
